<template>
  <div class="updatafile" v-loading="MD5Loading">
    <div class="updata_inner">
      <el-form
        :rules="rules"
        ref="form"
        :model="form"
        label-width="110px"
        class="form1"
        label-position="right"
      >
        <el-form-item label="文件名称：" prop="title">
          <el-input
            :maxlength="50"
            v-model="form.title"
            placeholder="请输入文件名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="原创类型：" prop="produceType">
          <el-select v-model="form.produceType" clearable placeholder="请选择原创类型">
            <el-option
              :label="item.name"
              :value="item.index"
              v-for="item in produceTypeOptions"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="item.title + '：'"
          v-for="item in selectList"
          :key="item.id"
        >
          <el-select
            v-model="formType['big' + item.id]"
            clearable
            :placeholder="'请选择' + item.title"
          >
            <el-option
              v-for="chItem in item.children"
              :key="chItem.id"
              :label="chItem.title"
              :value="chItem.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="中英双语类：">
          <el-checkbox @change="changebilg" v-model="bilingual"></el-checkbox>
        </el-form-item>
        <el-form-item label="文件标签：" prop="tags">
          <el-tag
            style="margin-right: 10px; margin-left: 0"
            :key="tag"
            v-for="tag in form.tags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            maxlength="10"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput"
          >+ 添加标签
          </el-button
          >
          <div class="notes">
            <i>注：</i>
            <span>1.标签长度建议4个字</span>
            <br/>
            <span>2.默认批量上传的文件使用相同标签</span>
          </div>
        </el-form-item>
        <el-form-item label="文件上传：" prop="uploadId" v-if="urlstatus">
          <div class="upload_style">
            <div class="file_name">
              {{ originalName }}
            </div>
            <uploader
              v-if="isShowUploader"
              ref="uploader"
              :options="options"
              :autoStart="false"
              @file-added="onFileAdded"
              class="uploader-app"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-btn
                id="global-uploader-btn"
                :single="true"
                :attrs="attrs"
                ref="uploadBtn"
              >
                修改
              </uploader-btn>
            </uploader>
          </div>
          <div>
            <p
              class="line"
              v-if="fileDetail.isprogress"
              :style="{ width: fileDetail.progress }"
            ></p>
            <p class="line errLine" v-else :style="{ width: fileDetail.progress }"></p>
          </div>
        </el-form-item>
        <el-form-item label="资源链接：" v-else prop="htmlUrl">
          <div>
            <el-input
              placeholder="请输入资源链接地址"
              v-model="form.htmlUrl"
            >
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="文件封面：">
          <el-upload
            class="avatar-uploader"
            accept=".jpeg,.png,.jpg"
            :action="imgUrl"
            :data="imgData"
            :headers="header"
            :show-file-list="false"
            :on-success="handleAvatarSuccessFen"
            :before-upload="beforeAvatarUploadFen"
            v-if="urlstatus"
          >
            <img
              v-if="form.coverUrl"
              :src="$http.requrl + '/profile/' + form.coverUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            accept=".jpeg,.png,.jpg"
            :action="imgUrltwo"
            :data="imgData"
            :headers="header"
            :show-file-list="false"
            :on-success="handleAvatar"
            :before-upload="beforeAvatarUploadFen"
            v-else
          >
            <img
              v-if="form.coverUrl"
              :src="$http.requrl + '/profile/' +   form.coverUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <!-- 上传的两个视频 -->
        <el-form-item label="实验简介视频：">
          <div class="upload_box">
            <video
              :src="formatUrl(form.introductionUrl)"
              controls
              controlsList="nodownload"
            ></video>
            <div class="updata_btn" @click="onupclick(1)">
              <uploader
                v-if="isShowUploader"
                ref="uploader"
                :options="options"
                :autoStart="false"
                @file-added="onFileAddedtwo"
                class="uploader-app"
              >
                <uploader-unsupport></uploader-unsupport>
                <uploader-btn
                  id="global-uploader-btn"
                  :single="true"
                  :attrs="attrstwo"
                  ref="uploadBtntwo"
                >
                  修改
                </uploader-btn>
              </uploader>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="教学引导视频：">
          <div class="upload_box">
            <video
              :src="formatUrl(form.teachingUrl)"
              controls
              controlsList="nodownload"
            ></video>
            <div class="updata_btn" @click="onupclick(2)">
              <uploader
                v-if="isShowUploader"
                ref="uploader"
                :options="options"
                :autoStart="false"
                @file-added="onFileAddedtwo"
                class="uploader-app"
              >
                <uploader-unsupport></uploader-unsupport>
                <uploader-btn
                  id="global-uploader-btn"
                  :single="true"
                  :attrs="attrstwo"
                  ref="uploadBtntwo"
                >
                  修改
                </uploader-btn>
              </uploader>
            </div>
          </div>
        </el-form-item>
        <!-- 富文本 -->
        <div class="xn_txt">
          <p v-if="form.zykMaterialMenus == null"></p>
          <el-tabs
            tab-position="top"
            v-model="activeName"
            @tab-click="handleClick"
            v-else
          >
            <el-tab-pane
              v-for="(item, index) in form.zykMaterialMenus"
              :key="index"
              :label="item.name"
              :name="item.name"
            >
              <Toolbar
                v-show="domeditorshow"
                style="border-bottom: 1px solid #ccc; height: 130px"
                :editor="item.editor"
                :defaultConfig="toolbarConfig"
                mode="default"
              />
              <Editor
                style="height: 500px; overflow-y: hidden"
                v-model="item.content"
                :defaultConfig="editorConfig"
                mode="default"
                @onCreated="onCreated"
                @onChange="onChange"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-form-item label="资源简介：" prop="description">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容(最多输入100字)"
            v-model="form.description"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="" v-show="false">
          <el-checkbox v-model="form.allowDownload">取消勾选该资源不可下载</el-checkbox>
        </el-form-item>
        <el-form-item label="">
          <el-button
            :loading="loading"
            type="primary"
            size="medium"
            @click="submitForm('form')"
          >保 存
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import SparkMD5 from "spark-md5";
import {Editor, Toolbar} from "@wangeditor/editor-for-vue";
import {DomEditor} from "@wangeditor/editor";

const ACCEPT_CONFIG = {
  image: [".png", ".jpg", ".jpeg", ".gif", ".bmp"],
  video: [".mp4", ".rmvb", ".mkv", ".wmv", ".flv"],
  document: [
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    ".pdf",
    ".txt",
    ".tif",
    ".tiff",
  ],
  getAll() {
    return [...this.image, ...this.video];
  },
};
export default {
  components: {Editor, Toolbar},
  data() {
    // 自定义验证 标签不能为空
    const checkLabel = (rule, value, callback) => {
      console.log(value);
      if (value.length > 0) {
        callback();
      } else {
        callback(new Error("标签不能为空"));
      }
    };
    return {
      form: {
        id: "",
        produceType: "",
        tags: [],
        title: "",
        coverUrl: "",
        description: "",
        allowDownload: false,
        uploadId: "",
        suffix: "",
        originalName: "",
        fileSize: "",
        resourceUrl: "",
        currentName: "",
        // 两个视频
        introductionUrl: "",
        teachingUrl: "",
        zykMaterialMenus: null, //富文本列表
        htmlUrl: null, //上传压缩包后返回的html链接
        loadingupload: null, //检验文件loading
        //中英双语类
        bilingual: 0,
      },
      // 小类
      formType: {},
      mediaTypeOptions: [],
      produceTypeOptions: [],
      rules: {
        tags: [{required: true, validator: checkLabel, trigger: "blue"}],
        title: [{required: true, message: "填写文件名称", trigger: "change"}],
        description: [{required: true, message: "填写资源简介", trigger: "change"}],
        uploadId: [{required: true, message: "请上传资源", trigger: "change"}],
        htmlUrl: [{required: true, message: "请填写资源链接地址", trigger: "change"}]
      },
      options: {
        target: "http://www.baidu.com",
        chunkSize: "2048000",
        fileParameterName: "upfile",
        maxChunkRetries: 3,
        testChunks: true, //是否开启服务器分片校验
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, message) {
          let objMessage = JSON.parse(message);
          if (objMessage.skipUpload) {
            return true;
          }
          return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0;
        },
        query: (file, chunk) => {
          return {
            ...file.params,
          };
        },
      },
      attrs: {
        accept: [".zip"],
      },
      imgUrl: "",
      imgUrltwo: "",
      header: {
        Authorization: "",
      },
      selectList: [],
      inputVisible: false,
      inputValue: "",

      imgData: {
        uploadId: "",
      },
      originalName: "",
      isShowUploader: true,
      fileDetail: {
        progress: "0%",
        isprogress: true,
      },
      detailData: {},
      loading: false,
      // tabs列表
      activeName: "实验简介",
      editorlist: [],
      domeditorshow: false,
      baseurl: this.$http.requrl,
      fileweizhi: null, //两个视频
      // md5页面计算loading
      MD5Loading: false,
      // 判断是否计算完毕的依据
      MD5Num: 0,
      attrstwo: {
        //accept: [...ACCEPT_CONFIG.getAll()],
        accept: [".mp4"],
      },
      toolbarConfig: {
        excludeKeys: ["uploadVideo", "emotion"],
      }, //去除富文本某些菜单
      editorConfig:{
        placeholder: '请输入内容...',
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            customUpload: this.uploadImageMe // this.uploadImageMe 是 methods 中的一个普通方法
          },
        }
      },
      bilingual: 0, //中英双语lei
      urlstatus: true, //true文件 false是链接
    };
  },
  created() {
    this.imgUrl = process.env.VUE_APP_BASE_API + "/business/upload/uploadCover";
    this.imgUrltwo = process.env.VUE_APP_BASE_API + "/common/upload";
    this.header["Authorization"] = localStorage.getItem("tooken");
    this.materialId = this.$route.query.id;

    this.getWebList();
    this.getMediaTypes();
    this.getProduceTypes();
  },

  mounted() {
  },
  methods: {
    formatUrl(url) {
      return url == null
        ? url
        : url.startsWith("/profile")
          ? this.baseurl + url
          : this.baseurl + "/profile/" + url;
    },
    //   个人信息详情
    filedetailsg() {
      this.isShowUploader = false;
      this.$http
        .get(
          "/business/material/details?materialId=" +
          this.materialId +
          "&userId=" +
          this.$store.state.userdata.user.userId
        )
        .then((res) => {
          if (res.code == 200) {
            this.isShowUploader = true;
            const detailData = res.data;
            this.detailData = detailData;
            // 回显form表单
            this.form.id = detailData.material.id;
            this.form.produceType = detailData.material.produceType;
            this.form.tags = detailData.material.tag.split(" ");
            this.form.title = detailData.material.title;
            this.form.coverUrl = detailData.material.coverUrl;
            this.form.description = detailData.material.description;
            this.form.allowDownload = detailData.material.allowDownload;
            this.form.suffix = detailData.material.suffix;
            this.form.originalName = detailData.material.originalName;
            this.form.fileSize = detailData.material.fileSize;
            this.form.resourceUrl = detailData.material.resourceUrl;
            this.form.currentName = detailData.material.currentName;
            // 两个视频
            this.form.introductionUrl = detailData.material.introductionUrl;
            this.form.teachingUrl = detailData.material.teachingUrl;
            // 暂无uploadId
            this.imgData.uploadId = detailData.material.uploadId;
            this.originalName = detailData.material.originalName;
            //富文本内容
            this.editlist(detailData.zykMaterialMenus);
            const arr = detailData.material.currentName.split(".");
            //压缩包的html链接
            this.form.htmlUrl = detailData.material.htmlUrl;
            const urlzz = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
            if (!urlzz.test(this.form.htmlUrl)) {
              this.urlstatus = true;
            } else {
              this.urlstatus = false;
            }
            //中英双语类
            this.form.bilingual = detailData.material.bilingual;
            if (this.form.bilingual == 0) {
              this.bilingual = false;
            } else {
              this.bilingual = true;
            }
            // 获取uploadId
            this.$http
              .post("/business/upload/getUploadId", null, {
                params: {
                  filemd5: arr[0],
                  suffix: arr[1],
                  size: detailData.material.fileSize,
                },
              })
              .then((res) => {
                if (res.code < 300) {
                  const data = res.data;
                  this.form.uploadId = data.uploadId;
                  this.imgData.uploadId = data.uploadId;
                } else {
                  // this.$message.warning('登录过期，请重新登录')
                }
              });
            detailData.types.forEach((v) => {
              this.formType["big" + v.typeBigId] = v.typeSmallId * 1;
            });
          }
        });
    },
    // 获取小类列表
    getWebList() {
      this.$http.get("/business/big/webList").then((res) => {
        if (res.code == 200) {
          res.rows.forEach((v) => {
            this.$set(this.formType, "big" + v.id, "");
          });
          this.selectList = res.rows;
          this.filedetailsg();
        }
      });
    },
    // 获取文件类型列表
    getMediaTypes() {
      this.$http.get("/business/big/getTypes").then((res) => {
        if (res.code == 200) {
          this.mediaTypeOptions = res.data;
        }
      });
    },
    // 获取原创类型列表
    getProduceTypes() {
      this.$http.get("/business/big/getProduceTypes").then((res) => {
        if (res.code == 200) {
          this.produceTypeOptions = res.data;
        }
      });
    },
    // 添加标签开始
    handleClose(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        if (this.form.tags.indexOf(inputValue) > -1) {
          this.$message.info("标签不能重复");
        } else {
          this.form.tags.push(inputValue);
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    // 添加上传的文件
    onFileAdded(file, fileList) {
      this.originalName = file.name;
      this.computeMD5(file);
      this.MD5Num++;
      this.MD5Loading = true;
      this.loading = false;
      this.fileDetail.isprogress = true; //重置进度条
      // 2022/1/10 将额外的参数赋值到每个文件上，解决了不同文件使用不同params的需求
      file.params = this.params;
    },
    // 生成文件的md5值
    computeMD5(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      // 文件状态设为"计算MD5"
      // this.statusSet(file.id, 'md5');
      file.pause();
      loadNext();
      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            $(`.myStatus_${file.id}`).text(
              "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%"
            );
          });
        } else {
          let md5 = spark.end();
          this.computeMD5Success(md5, file);
          this.MD5Num--;
          if (this.MD5Num == 0) {
            this.MD5Loading = false;
          }
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end = start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    // 上传文件的md5值
    computeMD5Success(md5, file) {
      this.loadingupload = this.$loading({
        text: "文件检验中......",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      file.uniqueIdentifier = md5;
      let fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1);
      this.$http
        .post("/business/upload/getUploadId", null, {
          params: {
            filemd5: md5,
            suffix: fileExtension,
            size: file.size,
            oldName: file.name.split(".")[0],
          },
        })
        .then((res) => {
          if (res.code < 300) {
            const data = res.data;
            let defaultImg = `default/${fileExtension}.png`;
            if (
              fileExtension == "png" ||
              fileExtension == "jpg" ||
              fileExtension == "jpeg"
            ) {
              defaultImg = `${res.data.url}`;
            }
            this.form.coverUrl = defaultImg;
            this.form.uploadId = data.uploadId;
            this.form.resourceUrl = data.url;
            this.imgData.uploadId = data.uploadId;
            this.form.currentName = md5 + "." + fileExtension;
            this.form.suffix = fileExtension;
            this.form.fileSize = file.size;
            this.form.originalName = file.name;
            this.form.htmlUrl = data.htmlUrl;
            this.PostFile(file, 0, data.custSize, data.indexCount, data.uploadId);
          } else {
            // this.$message.warning('登录过期，请重新登录')
          }
        })
        .catch((err) => {
          this.loadingupload.close();
        });
      // file.resume();
    },
    // 文件切片
    PostFile(file, i, shardSize, indexCount, uploadId) {
      // debugger
      var name = file.name, //文件名
        size = file.size, //总大小shardSize = 2 * 1024 * 1024,
        //shardSize = 10 * 1024 * 1024,                //以2MB为一个分片,每个分片的大小
        shardCount = Math.ceil(size / shardSize); //总片数
      if (i >= shardCount) {
        return;
      }
      //console.log(size,i+1,shardSize);  //文件总大小，第一次，分片大小//
      var start = i * shardSize;
      var end = start + shardSize;
      let blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      var packet = blobSlice.call(file.file, start, end); //将文件进行切片
      var form = new FormData();
      form.append("file", packet); //slice方法用于切出文件的一部分
      form.append("index", i + 1);
      form.append("uploadId", uploadId);
      this.$http.post("/business/upload/uploadIndex", form).then((res) => {
        if (res.code < 300) {
          if (!res.data) {
            this.fileDetail.progress = (i / shardCount) * 100 + "%";
            form = "";
            i++;
            this.PostFile(file, i, shardSize, indexCount, uploadId);
          } else {
            this.fileDetail.progress = "100%";
            // 文件上传完成
            this.$message.success("文件上传完成");
            this.loadingupload.close();
          }
        } else {
          this.fileDetail.isprogress = false;
          this.loadingupload.close();
          this.loading = true;
        }
      });
    },
    // 上传文件封面
    beforeAvatarUploadFen(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传封面图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传封面图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    // 封面上传成功
    handleAvatarSuccessFen(res, file) {
      this.form.coverUrl = res.msg;
    },
    handleAvatar(res, file) {
      this.form.coverUrl = res.fileName.replace('/profile/', ' ');
    },
    resUpdate(data) {
      this.loading = true;
      this.$http
        .post("/business/upload/update", data)
        .then((res) => {
          this.$router.push({path: "/profile-core/works"});
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.form));
          const newArr = [];
          for (var keys in this.formType) {
            if (this.formType[keys]) {
              newArr.push(this.formType[keys]);
            }
          }
          formData.types = newArr;

          this.resUpdate(formData);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传的tabs列表
    handleClick(tab) {
      console.log(tab.name);
    },
    //上传时的菜单列表
    editlist(rows) {
      this.form.zykMaterialMenus = rows;
      this.activeName = rows[0].name;
      var editlist = {
        editor: null,
      };
      //添加富文本属性参数
      for (let index = 0; index < this.form.zykMaterialMenus.length; index++) {
        this.form.zykMaterialMenus[index] = {
          ...this.form.zykMaterialMenus[index],
          ...editlist,
        };
      }
    },
    // 富文本
    onCreated(editor) {
      this.editorlist.push(editor);
      this.form.zykMaterialMenus.forEach((val, key) => {
        this.$set(val, "editor", Object.seal(this.editorlist[key]));
      });
      this.domeditorshow = true;
    },
    onChange(editor) {
      const toolbar = DomEditor.getToolbar(editor);
      // console.log("工具栏配置", toolbar.getConfig().toolbarKeys); // 工具栏配置
    },
    //上传两个视频 --- 点击视频上传框
    onupclick(keyp) {
      //keyp---代表是哪个视频  1-简介视频 2-教学视频
      this.fileweizhi = keyp;
    },
    // 实验简介视频上传
    onFileAddedtwo(file) {
      this.computeMD5two(file);
      this.MD5Num++;
      this.MD5Loading = true;
    },
    // 生成文件的md5值
    computeMD5two(file) {
      let fileReader = new FileReader();
      let time = new Date().getTime();
      let blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      let currentChunk = 0;
      const chunkSize = 10 * 1024 * 1000;
      let chunks = Math.ceil(file.size / chunkSize);
      let spark = new SparkMD5.ArrayBuffer();
      // 文件状态设为"计算MD5"
      // this.statusSet(file.id, 'md5');
      file.pause();
      loadNext();
      fileReader.onload = (e) => {
        spark.append(e.target.result);
        if (currentChunk < chunks) {
          currentChunk++;
          loadNext();
          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            $(`.myStatus_${file.id}`).text(
              "校验MD5 " + ((currentChunk / chunks) * 100).toFixed(0) + "%"
            );
          });
        } else {
          let md5 = spark.end();
          this.computeMD5Successtwo(md5, file);
          this.MD5Num--;
          if (this.MD5Num == 0) {
            this.MD5Loading = false;
          }
        }
      };
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`);
        file.cancel();
      };

      function loadNext() {
        let start = currentChunk * chunkSize;
        let end = start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      }
    },
    // 上传文件的md5值
    computeMD5Successtwo(md5, file) {
      file.uniqueIdentifier = md5;
      let fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1);
      this.$http
        .post("/business/upload/getUploadId", null, {
          params: {
            filemd5: md5,
            suffix: fileExtension,
            size: file.size,
          },
        })
        .then((res) => {
          if (res.code < 300) {
            const data = res.data;

            console.log(data.url, "data.url");
            this.PostFiletwo(
              file,
              0,
              data.custSize,
              data.indexCount,
              data.uploadId,
              data.url
            );
          } else {
          }
        });
    },
    // 文件切片
    PostFiletwo(file, i, shardSize, indexCount, uploadId, url) {
      const loadingupload = this.$loading({
        text: "视频努力上传中......",
        spinner: "el-icon-loading",
        background: "rgba(256, 256, 256, 0.7)",
      });
      // debugger
      var name = file.name, //文件名
        size = file.size, //总大小shardSize = 2 * 1024 * 1024,
        //shardSize = 10 * 1024 * 1024,                //以2MB为一个分片,每个分片的大小
        shardCount = Math.ceil(size / shardSize); //总片数
      if (i >= shardCount) {
        return;
      }
      //console.log(size,i+1,shardSize);  //文件总大小，第一次，分片大小//
      var start = i * shardSize;
      var end = start + shardSize;
      let blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      var packet = blobSlice.call(file.file, start, end); //将文件进行切片
      var form = new FormData();
      form.append("file", packet); //slice方法用于切出文件的一部分
      form.append("index", i + 1);
      form.append("uploadId", uploadId);
      this.$http.post("/business/upload/uploadIndex", form).then((res) => {
        if (res.code < 300) {
          if (!res.data) {
            i++;
            this.PostFiletwo(file, i, shardSize, indexCount, uploadId, url);
          } else {
            switch (this.fileweizhi) {
              case 1:
                this.form.introductionUrl = url;

                break;
              case 2:
                this.form.teachingUrl = url;
                break;
              default:
                break;
            }
            console.log(this.form, "this.form");
            loadingupload.close();
            this.$message.success("文件上传完成");
          }
        } else {
          loadingupload.close();
        }
      });
    },
    // 中英双语类
    changebilg(val) {
      this.bilingual = val;
      if (val == true) {
        this.form.bilingual = 1;
      } else {
        this.form.bilingual = 0;
      }
    },

    //上传文件配置
    uploadImageMe(file, insertFn){
      // file 即选中的文件
      // 自己实现上传，并得到图片 url alt href
      let name = file.name;
      let suffix = file.type.split("/")[1];
      name = name + '.' + suffix;

      let formdata = new FormData()
      formdata.append("file", file)

      this.$http.post("/common/upload", formdata).then((res) => {
        // 最后插入图片
        let url = process.env.VUE_APP_BASE_API + res.fileName;
        insertFn(url , res.fileName, url )
      });
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.updatafile {
  margin-top: 120px;

  .updata_inner {
    width: 600px;
    margin: auto;
    padding: 20px;
    background: #fff;
    margin-bottom: 50px;

    .line {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      width: 0%;
      background: #409eff;

      &.errLine {
        background: red;
      }
    }
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    // margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    // margin-left: 10px;
    vertical-align: bottom;
  }

  .notes {
    color: #999999;
    position: relative;
    padding-left: 30px;
    line-height: 1.5;
    margin-top: 20px;

    i {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .avatar-uploader ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 108px;
    display: block;
  }

  .upload_style {
    display: flex;

    .file_name {
      color: #666;
      max-width: 400px;
      overflow: hidden;
      text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
      white-space: nowrap; /*让文字不换行*/
    }

    #global-uploader-btn {
      margin-left: 10px;
      color: #409eff;
      border: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  // 富文本
  .xn_txt {
    border: 1px solid #ccc;
    margin-bottom: 20px;
  }

  //两个视频
  .upload_box {
    position: relative;

    video {
      width: 360px;
      height: 240px;
    }

    .updata_btn {
      position: absolute;
      right: 0;
      top: 20px;
    }
  }
}
</style>
